module.exports = __webpack_public_path__ + "static/img/BoxENG.9f137b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/GameStart/Steps/BoxENG.svg
// module id = 421
// module chunks = 0